"use client";

import { c as _c } from "react/compiler-runtime";
import { IconAlertTriangle } from "@tabler/icons-react";
import { useEffect } from "react";
import { isDevEnvironment } from "@/lib/env";
import { findProductDataMismatches } from "@/lib/product/productDataMismatches";
import { useProduct } from "@/queries/useProduct";
import { useProductBuilderContext } from "./ProductBuilderContext";
export default function ProductDataMismatchWarning() {
  const $ = _c(24);
  const {
    product
  } = useProductBuilderContext();
  const {
    data: productAdmin
  } = useProduct(product.sku);
  let t0;
  let t1;
  if ($[0] !== productAdmin) {
    t0 = () => {
      if (!productAdmin) {
        return;
      }
      if (!isDevEnvironment()) {
        return;
      }
      const mismatches = findProductDataMismatches(productAdmin);
      for (const mismatch of mismatches) {
        console.warn(`[product data] ${mismatch.label}="${mismatch.defaultValue}" not in [${mismatch.availableSkus.map(_temp).join(", ")}] for product ${productAdmin.sku}`);
      }
    };
    t1 = [productAdmin];
    $[0] = productAdmin;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  if (!productAdmin) {
    return null;
  }
  if (!isDevEnvironment()) {
    return null;
  }
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[3] !== productAdmin) {
    t8 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const mismatches_0 = findProductDataMismatches(productAdmin);
      if (mismatches_0.length === 0) {
        t8 = null;
        break bb0;
      }
      t6 = "flex gap-2 rounded-md border border-yellow-500 bg-yellow-50 p-3 text-sm";
      if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = <IconAlertTriangle className="mt-0.5 shrink-0 text-yellow-600" size={18} aria-hidden="true" />;
        $[11] = t7;
      } else {
        t7 = $[11];
      }
      t4 = "flex flex-col gap-1";
      if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = <p className="font-semibold text-yellow-900">Product data mismatch (dev only)</p>;
        $[12] = t5;
      } else {
        t5 = $[12];
      }
      t2 = "flex flex-col gap-0.5 text-yellow-900";
      t3 = mismatches_0.map(_temp3);
    }
    $[3] = productAdmin;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
  } else {
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
    t6 = $[8];
    t7 = $[9];
    t8 = $[10];
  }
  if (t8 !== Symbol.for("react.early_return_sentinel")) {
    return t8;
  }
  let t9;
  if ($[13] !== t2 || $[14] !== t3) {
    t9 = <ul className={t2}>{t3}</ul>;
    $[13] = t2;
    $[14] = t3;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t4 || $[17] !== t5 || $[18] !== t9) {
    t10 = <div className={t4}>{t5}{t9}</div>;
    $[16] = t4;
    $[17] = t5;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t6 || $[22] !== t7) {
    t11 = <output className={t6}>{t7}{t10}</output>;
    $[20] = t10;
    $[21] = t6;
    $[22] = t7;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  return t11;
}
function _temp3(mismatch_0) {
  return <li key={mismatch_0.label}><code>{mismatch_0.label}</code>=<code>"{mismatch_0.defaultValue}"</code> not in [{mismatch_0.availableSkus.map(_temp2)}]</li>;
}
function _temp2(sku_0, index) {
  return <span key={sku_0}>{index > 0 && ", "}<code>"{sku_0}"</code></span>;
}
function _temp(sku) {
  return `"${sku}"`;
}